import React, { FC, useEffect, useState } from 'react'
import { HoskingsButton } from '@components/ui'
import { connectInfiniteHits } from 'react-instantsearch-dom'
import cn from 'clsx'
import StatsWithProgressBar from '@components/common/StatsWithProgressBar'
import { slice, debounce } from 'lodash'

const GRID_LAYOUT_4 = 'GRID_LAYOUT_4'
const GRID_LAYOUT_1 = 'GRID_LAYOUT_1'

interface props {
  hits: []
  HitComponent: any
  hasMore: boolean
  refineNext: any
  searchState?: any
  totalProducts?: any
  gridSelectionDesktop?: any
  gridSelectionMobile?: any
  onSearchStateChange?: (state: any) => void
}

const AlgoliaInfiniteHits: FC<props> = ({
  hits,
  HitComponent,
  hasMore,
  refineNext,
  totalProducts,
  gridSelectionDesktop,
  gridSelectionMobile,
  searchState,
  onSearchStateChange,
}) => {
  const [scrollPosition, setScrollPosition] = useState(
    searchState?.position ?? 0
  )

  const handleScroll = debounce(() => {
    setScrollPosition(window.scrollY)
  }, 500)

  useEffect(() => {
    if (typeof window !== 'undefined' && hits.length) {
      setTimeout(() => {
        if (scrollPosition) {
          // Initial Scroll Position from URL
          window.scrollTo(0, scrollPosition)
        }

        document.addEventListener('scroll', handleScroll, { passive: true })
      }, 300)

      return () => {
        document.removeEventListener('scroll', handleScroll)
      }
    }
  }, [hits])

  useEffect(() => {
    if (onSearchStateChange) {
      onSearchStateChange({
        position: scrollPosition,
      })
    }
  }, [scrollPosition])

  const gridDesktop =
    gridSelectionDesktop === GRID_LAYOUT_4 ? `lg:grid-cols-4` : `lg:grid-cols-6`
  const gridMobile =
    gridSelectionMobile === GRID_LAYOUT_1 ? `grid-cols-1` : `grid-cols-2`

  return (
    <div>
      <div className="wrapper">
        <div
          className={cn(
            `pb-11 pt-6 grid ${gridMobile} ${gridDesktop} gap-5 gap-y-8 lg:gap-8 lg:gap-y-10`
          )}
        >
          {hits.map((hit: any, index: number) => {
            return (
              <div key={index}>
                <HitComponent key={index} hit={hit} />
              </div>
            )
          })}
        </div>
        <div className="body-2 text-text-subdued flex justify-center">
          Showing <span className="px-1">{hits.length}</span> of{' '}
          <span className="pl-1">{totalProducts}</span>
        </div>
        {hits.length > 0 && <StatsWithProgressBar hits={hits} />}
        <div className="flex justify-center pb-11 lg:pb-20">
          <HoskingsButton
            disabled={!hasMore}
            variant={hasMore ? "transparent" : "disabled"}
            width="200px"
            size="medium"
            onClick={() => {
              refineNext()
            }}
          >
            {hasMore ? 'Load more' : 'Showing all'}
          </HoskingsButton>
        </div>
      </div>
    </div>
  )
}

export default connectInfiniteHits(AlgoliaInfiniteHits)
